import React from 'react';
import styled from 'styled-components';
import { FaLinkedin, FaFacebook, FaInstagram, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, rgba(0, 20, 40, 0.95) 0%, rgba(0, 30, 60, 0.95) 50%, rgba(0, 20, 40, 0.95) 100%);
  backdrop-filter: blur(10px) saturate(180%);
  -webkit-backdrop-filter: blur(10px) saturate(180%);
  color: #fff;
  padding: 60px 0 20px;
  position: relative;
  border-top: 1px solid rgba(0, 123, 255, 0.2);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, 
      transparent 0%, 
      rgba(0, 123, 255, 0.5) 50%, 
      transparent 100%);
  }
`;

const FooterContent = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 40px;
  position: relative;
  z-index: 2;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const LogoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  
  img {
    height: 60px;
    width: 60px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 15px;
  }
  
  .tagline {
    font-size: 0.95rem;
    color: #bdc3c7;
    font-style: italic;
    line-height: 1.5;
  }
`;

const FooterSection = styled.div`
  h3 {
    margin-bottom: 20px;
    color: #007bff;
    font-weight: 600;
    text-shadow: 0 0 8px rgba(0, 123, 255, 0.3);
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 30px;
      height: 2px;
      background: linear-gradient(90deg, #007bff, #00d4ff);
      border-radius: 1px;
    }
  }
  
  p, li {
    margin-bottom: 10px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.9);
  }
  
  ul {
    list-style: none;
    padding: 0;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 0;
  align-items: center;
  
  a {
    color: #fff;
    font-size: 24px;
    transition: all 0.3s ease;
    padding: 10px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
    
    &:hover {
      color: #007bff;
      text-shadow: 0 0 8px rgba(0, 123, 255, 0.6);
      background: rgba(0, 123, 255, 0.1);
      transform: translateY(-2px);
    }
  }
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateX(5px);
  }
  
  svg {
    margin-right: 10px;
    color: #007bff;
    transition: all 0.3s ease;
  }
  
  &:hover svg {
    color: #00d4ff;
    text-shadow: 0 0 8px rgba(0, 123, 255, 0.6);
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(0, 123, 255, 0.2);
  margin-top: 40px;
  padding-top: 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(0, 123, 255, 0.5), transparent);
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <LogoSection>
          <img src="/logo.png" alt="DirectRoute NETWORKS" />
          <h3 style={{color: '#fff', margin: '0 0 8px 0', fontSize: '1rem', fontWeight: '600', lineHeight: '1.1'}}>Direct Route<br/>Networks</h3>
        </LogoSection>
        
        <FooterSection>
          <h3>Reach Us At:</h3>
          <ContactInfo>
            <FaEnvelope />
            <span>info@directroutenetworks.com</span>
          </ContactInfo>
          <ContactInfo>
            <FaPhone />
            <span>+1 (855) 608-8058</span>
          </ContactInfo>
          <ContactInfo>
            <FaMapMarkerAlt />
            <span>238 N. Massachusetts Avenue, 1st Floor, Lakeland, FL 33801</span>
          </ContactInfo>
        </FooterSection>
        
        <FooterSection>
          <h3>Useful Links</h3>
          <ul>
            <li><a href="/about" style={{color: '#fff', textDecoration: 'none'}}>About</a></li>
            <li><a href="/contact" style={{color: '#fff', textDecoration: 'none'}}>Contact</a></li>
            <li><a href="/blogs" style={{color: '#fff', textDecoration: 'none'}}>Blogs</a></li>
          </ul>
        </FooterSection>
        
        <FooterSection>
          <h3>Our Socials</h3>
          <SocialLinks>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
          </SocialLinks>
        </FooterSection>
      </FooterContent>
      
      <FooterBottom>
        <p>&copy; {new Date().getFullYear()} DIRECT ROUTE NETWORKS LLC. All rights reserved.</p>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;



